import { action, observable } from 'mobx';
import { dispatch } from 'rfx-core';

import { getChildLogger } from '#/shared/utils/client.logger';

export default class CreateShiftModal {
  log = getChildLogger('ui.CreateShiftModal');

  @observable
  isOpen = false;

  @observable
  isEdit = false;

  @observable
  lastSubmittedShiftId = null;

  @action
  setup({
    open = this.isOpen,
    edit = false,
    shift,
    company,
    preserveNotificationPrefs = false,
  }) {
    dispatch('ui.shiftFormNextGen.setup', {
      company,
      preserveNotificationPrefs,
      shift,
    });
    this.open(open);
    this.isEdit = edit;
  }

  @action
  open(arg = !this.isOpen) {
    this.isOpen = !!arg;
  }

  @action
  clear() {
    this.isOpen = false;
  }

  @action
  setLastSubmittedShift(shift) {
    this.lastSubmittedShiftId = shift?.uuid ?? shift;
  }
}
